import { Trans } from 'react-i18next';

import { VisitMedicalInformation } from '@dreryk/egabinet-visit-frontend-api';

import { dateFormatter, hourMinuteFormatter } from '@dreryk/react-common';
import { appendTestableComponentAttributes, StyledFlex } from '@dreryk/react-components';

import { visitHistoryTranslationKeys } from '../translations';

import { VisitHistoryOtherExaminationAttachmentLoader } from './VisitHistoryOtherExaminationAttachment.loader';
import { StyledVisitHistoryText } from './VisitHistoryText.styled';
import { VisitHistoryOtherExaminationAttachment } from './VisitHistoryOtherExaminationAttachment';

type VisitHistoryOtherExaminationItemProps = {
   readonly visitMedicalInformation: VisitMedicalInformation;
};

export const VisitHistoryOtherExaminationItem = (props: VisitHistoryOtherExaminationItemProps): JSX.Element | null => {
   return (
      <StyledFlex
         direction={'column'}
         gap={4}
         {...appendTestableComponentAttributes(
            'VisitHistoryOtherExaminationItem',
            props.visitMedicalInformation.medicalInformationId
         )}
      >
         <div>
            <StyledVisitHistoryText testId={'examinationDate'}>
               <Trans
                  i18nKey={visitHistoryTranslationKeys.otherExaminationExaminationDate}
                  values={{
                     date: dateFormatter(props.visitMedicalInformation.creationDate),
                     time: hourMinuteFormatter(props.visitMedicalInformation.creationDate),
                  }}
               />
            </StyledVisitHistoryText>

            <div>
               <StyledVisitHistoryText testId={'description'}>
                  <Trans
                     i18nKey={visitHistoryTranslationKeys.otherExaminationDescription}
                     values={{
                        description: props.visitMedicalInformation.description.trim(),
                     }}
                  />
               </StyledVisitHistoryText>
            </div>
         </div>

         <VisitHistoryOtherExaminationAttachmentLoader
            visitMedicalInformationId={props.visitMedicalInformation.medicalInformationId}
         >
            {({ medicalInformationAttachments }) => (
               <VisitHistoryOtherExaminationAttachment medicalInformationAttachments={medicalInformationAttachments} />
            )}
         </VisitHistoryOtherExaminationAttachmentLoader>
      </StyledFlex>
   );
};
